import { supabase } from '@/lib/supabaseClient';

/**
 * Что показать пользователю про его приглашения.
 *
 * Клиент только читает: referrals заводит onboard_user, а награждает
 * qualify_referral после первой успешной генерации приглашённого. RLS
 * отдаёт лишь свои строки, поэтому фильтр по referrer_id не нужен.
 */
export interface ReferralSummary {
  code: string;
  invited: number;
  /** Приглашения, за которые награда уже начислена. */
  rewarded: number;
  /** Пришли, но первого портрета ещё не сделали — награды пока нет. */
  waiting: number;
}

export async function fetchReferralSummary(): Promise<ReferralSummary | null> {
  if (!supabase) {
    return null;
  }

  const { data: profile, error: profileError } = await supabase
    .from('profiles')
    .select('referral_code')
    .maybeSingle();

  if (profileError) {
    throw new Error('Не удалось загрузить приглашения.');
  }

  const code = (profile as { referral_code: string } | null)?.referral_code;

  if (!code) {
    return null;
  }

  const { data, error } = await supabase.from('referrals').select('status');

  if (error) {
    throw new Error('Не удалось загрузить приглашения.');
  }

  const rows = (data ?? []) as { status: string }[];

  return {
    code,
    invited: rows.length,
    rewarded: rows.filter((row) => row.status === 'rewarded').length,
    waiting: rows.filter((row) => row.status === 'pending').length,
  };
}
